/**
 * Payment mode recorded on a receipt (mirrors the backend PaymentModeEnums).
 * Distinct from PaymentMethod, which is the customer-facing checkout method.
 */
export enum PaymentModeEnum {
    RAZORPAY = "RAZORPAY",
    CASH = "CASH",
    OTHER = "OTHER",
}

/** Modes an admin may record when money was collected outside razorpay. */
export const OFFLINE_PAYMENT_MODES = [
    PaymentModeEnum.CASH,
    PaymentModeEnum.OTHER,
];
